import React from "react";

import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import AddIcon from "@/icons/AddIcon";
import {
  addIconCss,
  actionListContainerCss,
  buttonActionCss,
} from "./ActionButtonList.style";

const propTypes = {
  /**
   * List of actions to be rendered as buttons.
   */
  actionsList: PropTypes.arrayOf(
    PropTypes.exact({
      label: PropTypes.string.isRequired,
      flavor: PropTypes.string.isRequired,
      icon: PropTypes.string,
      handleClick: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
};

const ActionButtonList = ({ actionsList }) => {
  const setIcon = (icon) => {
    switch (icon) {
      case "add":
        return {
          iconNode: <AddIcon css={addIconCss} />,
          isIconBeforeText: true,
        };
      /* ... Icon actions will be added as needed ... */
      default:
        break;
    }
  };

  return (
    <div css={actionListContainerCss}>
      {actionsList.map((value, index) => {
        return (
          <Button
            flavor={value.flavor}
            disabled={value.disabled}
            onClick={value.handleClick}
            icon={setIcon(value.icon)}
            __cssFor={{
              root: buttonActionCss,
            }}
            aria-label={value.label}
            key={index}
          >
            {value.label}
          </Button>
        );
      })}
    </div>
  );
};

ActionButtonList.propTypes = propTypes;

export default ActionButtonList;
